import React from 'react';
import { goBack } from 'react-router-redux';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';

@connect()
export default class extends React.Component {
  constructor(props){
    super(props);
  }
  mainLink = () => {
    this.props.dispatch(goBack());
  }
  render(){
    return(
      <RaisedButton
        label="Volver"
        onTouchTap={this.mainLink}
        fullWidth={true}
        backgroundColor='#FFEB3B'
        labelColor='black'
        type='submit'
        className='cancelarButtom'/>
      );
    }
  }



// WEBPACK FOOTER //
// src/modules/general/components/volverButtom.js